import React, { Component } from "react";
import Navbar from "../navbar/navbar";
import "./anouncements.css";
import "../home/home.css";
import announcements from "./announcements.json";
class Announcements extends Component {
  render() {
    return (
      <>
        <div className="header-area">
          <div id="home" className="contact-header-area  bg_cover">
            <Navbar />
            <div className=" d-flex align-items-center">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-lg-10">
                    <div className="header-content text-center">
                      <h2 className="header-title2">ANNOUNCEMENTS</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="schedule-section row">
          <table className="annoucement-table container">
            <tr className="annoucement-table-header-row">
              <th>Deadline</th>
              <th>Dates</th>
            </tr>
            {announcements &&
              announcements.map((a, key) => (
                <tr className="announcement-table-row">
                  <td className="annoucement-title">{a?.title}</td>
                  <td dangerouslySetInnerHTML={{ __html: a?.date }} />
                </tr>
              ))}
          </table>
        </div>
      </>
    );
  }
}

export default Announcements;
